import { gql } from "@apollo/client";

/**
 * @deprecated Shared fragments are deprecated. Indicate field name directly within query/mutation or
 * create a co-located (not shared) fragment, if you need one.
 */
const STORE_SETUP_FRAGMENT = gql`
  fragment StoreSetupFragment on StoreSetup {
    id
    currentStep
    currentStepNumber
    nextStep {
      neverMargin
      variableMargin
    }
    previousStep
    totalStepCount {
      neverMargin
      variableMargin
    }
    stepDetails {
      name
      stepCompleted
    }
  }
`;

export { STORE_SETUP_FRAGMENT };
